import { useCustom } from '@refinedev/core';
import { Card, Col, Progress, Row, Space, Typography } from 'antd';
import { Column, Pie } from '@ant-design/charts';
import { BOTTOM_LEGEND } from '@/pages/dashboard/chartLegend';
import type { ConsentRateOut, UserStatsOut } from '@/api/generated/schemas';

export const UserComposition = () => {
  const { query: statsQuery } = useCustom<UserStatsOut>({
    url: 'iam/users/stats/',
    method: 'get',
  });

  const { query: consentQuery } = useCustom<ConsentRateOut[]>({
    url: 'iam/consents/stats/',
    method: 'get',
  });

  const stats = statsQuery.data?.data;

  const pieData = stats
    ? [
        { type: 'Zweryfikowani', value: stats.verified },
        { type: 'Niezweryfikowani', value: stats.unverified },
        { type: 'Anonimowi', value: stats.anonymous },
      ]
    : [];

  const oauthData = stats?.oauth_providers
    ? Object.entries(stats.oauth_providers).map(([provider, count]) => ({
        provider,
        count,
      }))
    : [];

  const consents = consentQuery.data?.data ?? [];

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} md={8}>
        <Card title="Skład użytkowników" loading={statsQuery.isLoading}>
          <Pie
            data={pieData}
            angleField="value"
            colorField="type"
            innerRadius={0.6}
            height={200}
            legend={BOTTOM_LEGEND}
            tooltip={{
              items: [
                (d: (typeof pieData)[number]) => ({
                  name: d.type,
                  value: d.value,
                }),
              ],
            }}
          />
        </Card>
      </Col>

      <Col xs={24} md={8}>
        <Card title="Konta OAuth" loading={statsQuery.isLoading}>
          {oauthData.length > 0 ? (
            <Column
              data={oauthData}
              xField="provider"
              yField="count"
              height={200}
              label={{ position: 'top' }}
              tooltip={{
                items: [
                  (d: (typeof oauthData)[number]) => ({
                    name: 'Konta',
                    value: d.count,
                  }),
                ],
              }}
            />
          ) : (
            <Typography.Text type="secondary">Brak danych</Typography.Text>
          )}
        </Card>
      </Col>

      <Col xs={24} md={8}>
        <Card title="Wskaźniki zgód" loading={consentQuery.isLoading}>
          <Space direction="vertical" style={{ width: '100%' }}>
            {consents.length > 0 ? (
              (consents as ConsentRateOut[]).map((c) => (
                <div key={c.kind}>
                  <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                    {c.kind}
                  </Typography.Text>
                  <Progress
                    percent={Math.round(c.rate * 100)}
                    size="small"
                    status="normal"
                  />
                </div>
              ))
            ) : (
              <Typography.Text type="secondary">Brak danych</Typography.Text>
            )}
          </Space>
        </Card>
      </Col>
    </Row>
  );
};
